import {Page} from "../js/page";
import {GvfService} from "../../gvf/js/gvf-service";
import {UtilsService} from "../js/utils-service";

export class RegisterPage extends Page{


    ready(){

        this.findMember("get-subscription-plans-button").click(
            (ev)=> {
                ev.preventDefault();
                const subscriptionPlanType = $(ev.currentTarget).data("subscription-plan-type");
                GvfService.endpoint(
                    "/cp/login/get-subscription-plans-url",
                    {subscriptionPlanType: subscriptionPlanType}
                ).then((resp) => {
                        window.location.href = resp;
                    }
                ).catch(UtilsService.alertEndpointResponse);
            }
        );

        this.findMember("go-login-button").click(
            (ev)=> {
                ev.preventDefault();
                window.location.href = "/";
            }
        );

        const plans = document.querySelectorAll('.js-login-page__plan');
        const selectButton = this.findMember("select-subscription-plan-button");

        plans.forEach(plan => {
            plan.addEventListener('click', function() {
                plans.forEach(p => p.classList.remove('is-selected'));
                this.classList.add('is-selected');
                selectButton.prop("disabled", false);
            });
        });

        selectButton.click((ev) => {
            ev.preventDefault();
            const selectedPlan = document.querySelector('.cp-register-page__plan.is-selected');

            const selectedPlanId = selectedPlan.getAttribute('data-subscription-plan-id');
            const supplierSubscriptionCode = selectedPlan.getAttribute('data-supplier-subscription-code');
            GvfService.endpoint(
                "/cp/login/get-subscription-plans-url",
                {supplierSubscriptionCode: supplierSubscriptionCode, subscriptionPlanId: selectedPlanId}
            ).then((resp) => {
                    window.location.href = resp;
                }
            ).catch(UtilsService.alertEndpointResponse);
        });

        selectButton.prop("disabled", true);
    }
}

